import React from 'react';
import PropTypes from 'prop-types';
import styles from './Terms.module.scss';


class Terms extends React.Component {
    state = {
    }

    update_data(props) {

    }

    refresh() {

    }

    update_data(props) {
    }

    componentWillReceiveProps(props) {
    }
    
    componentWillMount(props) {
    }

    componentWillUnmount(){
    }

    render() {
      const { t, i18n } = this.props;

      return (

      <div id="terms" className="page-wrapper" >
        <div className="page-header section-padding section-padding-extra dc-two pb-0">
          <div className="container" style={{"background" : "#fff"}}>
            <h1 dir="rtl">{t("Regulations/contract/agreement between the users of the website and the website and its operators")}</h1>
            <div className="row">
              <div className="col-md-12">
      <div>
        <p dir="rtl">{t("introduction")}</p>
        <ol>
          <li dir="rtl">
            <p dir="rtl">{t("Company Name")}</p>
          </li>
        </ol>
        <p><br /></p>
        <p dir="rtl">שם החברה באנגלית הינו "FBzipper"&nbsp;או "אפביזיפר" בעברית.&nbsp;<br /><br /></p>
        <ol start={2}>
          <li dir="rtl">
            <p dir="rtl">{t("The purpose of the company")}</p>
          </li>
        </ol>
        <p><br /></p>
        <p dir="rtl">{t("The purpose of the company is to engage in any legal occupation.")}&nbsp;</p>
        <p><br /></p>
        <ol start={3}>
          <li dir="rtl">
            <p dir="rtl">{t("General conditions")}</p>
          </li>
        </ol>
        <p><br /></p>
        <ul>
          <li dir="rtl">
            <p dir="rtl">אתר&nbsp;"<a href="http://fbzipper.com">fbzipper.com</a>"&nbsp;{t("(hereinafter: 'the website') is a website on the Internet, which is online software for advertising products and services by the Internet surfing public. The owner and operator of the site is,")}&nbsp;FBzipper&nbsp;{t("below:")}, {t("Beer Sheva")}, {t("whose registered office is at 19 Oli Gerdom St")}, 8442065 ({t("(licensed dealer) H.P. 314735184")} "FBzipper").</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">ביצוע כל פעולה באמצעות האתר / התוכנה כפוף לתנאים המפורטים בתקנון זה. הנך מתבקש לקרוא תקנון זה במלואו ובקפידה. פעולה באתר / בתוכנה הינה כל פעולה המבוצעת באתר, לרבות רכישת מוצרים ו/או שירותים המוצעים באתר (להלן: "פעולה").</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">בביצוע רכישת מוצר באתר מצהיר המשתמש כי קרא את הוראות תקנון זה, הבין אותן והסכים להן.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">הוראות תקנון זה יחולו על כל פעולה שתבוצע באתר / בתוכנה על ידי "המשתמש", כהגדרתו להלן ויהוו חוזה התקשרות מחייב בין המשתמש ובין החברה, לכל דבר ועניין. מובהר כי גלישה באתר ו/או ביצוע פעולות באתר / בתוכנה, מהוות הסכמת המשתמש לקבל ולנהוג על פי הוראות התקנון. אם אינך מסכים לתנאי מתנאי תקנון זה, הנך מתבקש לא לעשות כל שימוש באתר. ויודגש, כל המבצע פעולה באתר / בתוכנה מצהיר כי הינו מודע להוראת תקנון האתר ומקבלם, וכי לא תהא לו ו/או למי מטעמו כל טענה ו/או תביעה כנגד בעלי האתר ו/או מפעיליו ו/או מי מטעמם מלבד טענות הקשורות בהפרת התחייבויות בעלי האתר / התוכנה ו/או מפעיליו על פי תקנון וכללי השתתפות אלו.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">לצורך תקנון זה, "משתמש" הינו - כל אדם, לרבות חברה, רשאי להשתמש באתר, לרבות לבצע פעולות באמצעות האתר, ובלבד שעמדה בכל התנאים המפורטים להלן&nbsp;במצטבר:&nbsp;</p>
            <ul>
              <li dir="rtl">
                <p dir="rtl">המשתמש הנו כשיר לבצע פעולות משפטיות מחייבות; במידה והנך קטין (מתחת לגיל 18) או אינך זכאי לבצע פעולות משפטיות ללא אישור אפוטרופוס, הנך נדרש ליידע את הוריך ו/או את האפוטרופוסים החוקיים שלך (להלן: "ההורים") בדבר הוראות תקנון זה ולקבל את אישורם לביצוע כל פעילות, מכל סוג שהוא, במסגרת האתר. על ההורים חלה אחריות ליידע את הקטינים המעוניינים לגלוש באתר בדבר התקנון וכן לפקח על פעילות הקטינים בכדי שהקטינים יפעלו על פי תנאי תקנון זה. כל פעילות אשר תבוצע על ידי הקטינים באתר מהווה הסכמה של הקטינים ו/או ההורים לאמור בתנאי התקנון.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">המשתמש הנו בעל כרטיס אשראי ישראלי או בינלאומי תקף.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">המשתמש הוא בעל תא דואר אלקטרוני פעיל ברשת האינטרנט.</p>
              </li>
            </ul>
          </li>
        </ul>
        <p dir="rtl">תנאים כלליים</p>
        <ul>
          <li dir="rtl">
            <p dir="rtl">fbzipper&nbsp;שומרת לעצמה את הזכות, על פי שיקול דעתה הבלעדי וללא הודעה מראש, להפסיק את פעילות האתר בכל עת ו/או למנוע את הגישה לאתר ו/או למנוע את האפשרות לבצע רכישות באתר ו/או לבטל את השתתפותו של משתמש הנוגדת את התקנון ו/או שהתנהגותו אינה הולמת או עשויה לפגוע בניהולו התקין של האתר.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">האמור בתקנון זה בלשון זכר הוא לשם הנוחות בלבד והתקנון מתייחס לבני שני המינים באופן שווה.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">כותרות הסעיפים בתקנון זה נועדו לשם נוחות והתמצאות בלבד ואין בהן כדי לשמש לשם פרשנותו.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">תקנון זה ניתן לשינוי ו/או עדכון בכל עת ע"י&nbsp;fbzipper&nbsp;/או מי מטעמה, על פי שיקול דעתה הבלעדי.</p>
          </li>
        </ul>
        <p dir="rtl">המוצרים / השירותים המוצעים באתר</p>
        <ul>
          <li dir="rtl">
            <p dir="rtl">האתר מציע מגוון תכנים ו/או שירותים ו/או פעולות, כגון אלו המפורטות מטה ואולם&nbsp;fbzipper&nbsp;אינה מתחייבת כי כל התכנים ו/או השירותים הללו יינתנו באופן רציף ושוטף באתר והיא רשאית לשנות את רשימת התכנים ו/או השירותים הניתנים באתר לפי שיקול דעתה הבלעדי ומבלי ליתן על כך הודעה מוקדמת כלשהי, לרבות בהתייחס לסל השירותים ו/או הפעולות המפורט להלן:</p>
            <ul>
              <li dir="rtl">
                <p dir="rtl">גלישה ועיון בתכנים שונים</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">רכישת מוצרים ו/או שירותים</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">יצירת רשימת פריטים מועדפים</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">הרשמה לדיוור (קבלת מידע תכני, שיווקי ופרסומי באמצעי מדיה שונים לפי בחירת המשתמש)</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">שיתוף ושליחת פריטים מן האתר ע"י המשתמש אל חבריו ומכריו בדוא"ל ו/או באמצעות שיתוף ברשתות חברתיות</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">תיוג פריט או שיבחר על ידי המשתמש באמצעות רשתות חברתיות</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">מתן משוב ו/או תגובות לפריטים ו/או תכנים ופרסומם באתר ו/או בדף הפייסבוק של&nbsp;fbzipper. מובהר כי&nbsp;fbzipper&nbsp;רשאית לבחור, על פי שיקול דעתה הבלעדי והמוחלט, באם לפרסם או למנוע את פרסום המשוב. עוד מובהר כי&nbsp;fbzipper&nbsp;רשאית לבחור לפסול ו/או שלא להעלות לאתר ו/או לדף&nbsp;fbzipper&nbsp;בפייסבוק כל תגובה ו/או משוב ו/או תמונה ו/או תוכן (להלן: "תוכן משתמש"), אשר על פי שיקול דעתה הבלעדי והמוחלט, עשוי לפגוע בשמה של&nbsp;fbzipper&nbsp;ו/או ברגשות הציבור ו/או הינו בעל אופי בוטה או פוגעני באופן מיני או אחר ו/או שהוא עשוי לגרום להפרת זכויות קניין כלשהן ו/או שהוא נוגד את הוראות הדין ו/או מכל טעם אחר. המשתמש מאשר כי יימנע מכל פגיעה במוניטין של&nbsp;fbzipper&nbsp;ובכלל זה להימנע מכל פעילות באתר אשר עלולה לפגוע בשמה הטוב של&nbsp;fbzipper&nbsp;בעיני הציבור. כל משתמש בשירותים המוצעים באתר מצהיר ומאשר בזאת, כי הוא נותן ל-&nbsp;fbzipper&nbsp;את זכות השימוש המלאה והבלעדית בתכנים ומאשר ומתחייב כי&nbsp;fbzipper&nbsp;תהיה רשאית להשתמש בשמו ו/או בתמונתו בהצגת התוכן באתר. זכות זו של&nbsp;fbzipper&nbsp;תישמר ללא הגבלת זמן. כמו כן, המשתמש בשירותים מאשר כי הוא מודע לכך כי מרגע פרסום המשוב ו/או התגובות, השיתוף, התיוג והעלאת ותכנים מכל סוג לאתר ו/או לדף הפייסבוק, תהיינה פעולותיו אלה חשופות לציבור, על כל המשתמע מכך.</p>
              </li>
            </ul>
          </li>
        </ul>
        <p dir="rtl">&nbsp;הרכישה באתר</p>
        <ul>
          <li dir="rtl">
            <p dir="rtl">האתר מאפשר, בין היתר, בחירת ורכישת חבילת שירות מבין החבילות השירותים המופיעים באתר, באופן קל, נוח ומהיר. כדי לבצע הזמנה יש תחילה לבחור את המוצר או השירות המבוקשים. עבור כל מוצר או שירות המוצע באתר יוצג "דף מכירה" בו יופיעו פרטי המוצר או השירות המוצע ומחיר המכירה (להלן "דף המכירה").&nbsp;fbzipper&nbsp;רשאית לעדכן את דף המכירה מעת לעת, להוסיף או להחסיר פרטים ו/או מוצרים וכן לעדכן ו/או לשנות את מחיר המוצר / השירות מעת לעת.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">התמונות המוצגות באתר הינן להמחשה בלבד. ייתכנו הבדלים בין מראה ומפרט המוצר לבין התמונה. בכל מקרה של סתירה בין המפרט בפועל לבין המתואר בתמונה, המפרט בפועל יהיה המפרט המחייב.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">המחירים המוצגים באתר כוללים מע''מ על-פי דין, אלא אם צוין אחרת במפורש.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">על מנת לבצע רכישה באתר, יתבקש המשתמש לבחור סיסמא, וכן להקליד פרטים בסיסיים כגון שם, כתובת, כתובת דואר אלקטרוני, מספר טלפון ומספר כרטיס אשראי. על מנת שההזמנה תבוצע במהירות וללא תקלות יש להקפיד על מסירת הפרטים הנכונים (להלן: "ביצוע ההזמנה"). לידיעתכם, מסירת פרטים כוזבים ביודעין עשויה להוות עבירה פלילית ועשויים להינקט צעדים משפטיים (אזרחיים ו/או פליליים) כנגד מי שמסר פרט כוזב, לרבות תביעת שיפוי בגין נזקים שייגרמו, אם ייגרמו, עקב שיבוש הפעלת האתר. בהתאם לאישור המשתמש, יוכל לשמש המידע שיימסר על ידי המשתמש באתר גם לשליחת דואר אלקטרוני בנוגע למבצעים מיוחדים או עדכונים באתר.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">במעמד ביצוע ההזמנה תבצע&nbsp;fbzipper&nbsp;בדיקה של פרטי כרטיס האשראי ועם קבלת אישור ההזמנה ע"י חברות כרטיסי האשראי, תימסר למשתמש הודעה מתאימה כי ההזמנה אושרה. מובהר כי חיוב המשתמש בגין רכישת הפריט או השירות יבוצע באמצעות כרטיס האשראי מיד בסיום ביצוע ההזמנה.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">תנאי תשלום:&nbsp;התשלום יהיה באמצעות פלטפורמת&nbsp;"פייפל - PayPal"&nbsp;הידועה. התשלום הוא מאובטח ביותר ואנו מכבדים את כל סוגי האשראי. החיוב בעבור החבילות יהיה תשלום בהוראת קבע חודשית ע"פ החבילה שבחרתם.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">תנאים להשלמת עסקת הרכישה:</p>
            <ul>
              <li dir="rtl">
                <p dir="rtl">עסקת הרכישה תבוצע רק לאחר השלמת תהליך ההזמנה וקבלת אישור מחברת כרטיסי האשראי על ביצוע החיוב. במקרה בו לא אושרה העסקה ע"י חברת האשראי - יקבל הלקוח הודעה מתאימה.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">השלמת עסקת הרכישה מותנית גם בכך שהפריטים המבוקשים קיימים במלאי בעת השלמת הליך ההזמנה. במקרה של פריט אשר אזל מן המלאי ו/או שישנה בעיה באספקתו, מכל סיבה שהיא, תהיה&nbsp;fbzipper&nbsp;רשאית להודיע למשתמש על ביטול ההזמנה. הודעה כאמור תימסר למשתמש באמצעות דואר אלקטרוני ו/או בהודעה טלפונית, לפי שיקול דעתה הבלעדי של&nbsp;fbzipper. במקרה כאמור, לא תהיה למשתמש טענה כלשהי כנגד&nbsp;fbzipper&nbsp;ובעצם ביצוע ההזמנה, מוותר המשתמש על כל טענה כאמור.&nbsp;fbzipper&nbsp;שומרת לעצמה את הזכות להגביל את כמות הפריטים בכל הזמנה.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">ההזמנה תירשם במחשבי&nbsp;fbzipper&nbsp;וניתן יהיה לראותה ולעקוב אחר הטיפול בה&nbsp;בקישור&nbsp;"חבילות שירות"&nbsp;שבאתר.&nbsp;כמו כן יישלח אישור בדואר אלקטרוני על ביצוע הפעולה בתוך 48 שעות מסיום ביצוע עסקת הרכישה על ידי המשתמש באתר. יובהר ויודגש, משלוח הודעת דואר אלקטרוני בדבר רישום ההזמנה במערכת של הממוחשבת של&nbsp;fbzipper&nbsp;אינה מהווה ראיה בדבר השלמת הפעולה ואין במשלוח הודעת הדוא"ל כדי לחייב את&nbsp;fbzipper. מובהר כי רישומי מערכת המחשב של&nbsp;fbzipper, הכוללים רישום ממוחשב ואוטומטי של כל הפעולות באתר, מהווים ראיה מכרעת לאמור בהם.</p>
              </li>
            </ul>
          </li>
        </ul>
        <p dir="rtl">אספקה</p>
        <ul>
          <li dir="rtl">
            <p dir="rtl">אלא אם צוין מפורשות אחרת בדף המכירה של המוצר ו/או השירות, לאחר השלמת ביצוע פעולת הרכישה ובתוך עד 3 ימי עסקים ממועד אישור ההזמנה ע"י חברת האשראי, מתחייבת&nbsp;fbzipper&nbsp;לספק את המוצר ו/או השירות שנרכשו לכתובת הדואר האלקטרוני כפי שהוקלדה בדף ההזמנה. הפריטים מסופקים כקובץ דיגיטלי הניתן להורדה מקישור שיישלח למשתמש שהשלים בהצלחה את פעולת הרכישה, בצירוף קוד אקטיבציה מספרי לשם הפעלת התוכנה.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">זמני האספקה המפורטים לעיל הינם זמנים משוערים וייתכנו שינויים בזמני האספקה עקב עיכובים התלויים בצד ג', לרבות יצרן הפריטים, אשר אינם תלויים בfbzipper. המשתמש מאשר כי ידוע לו שייתכן ואספקת הפריטים תיעשה בתוך זמן קצר או ארוך יותר מן הזמן המשוער וכי ידוע לו שfbzipper&nbsp;לא תהא אחראית לאיחור באספקת הפריטים במקרים הבאים:</p>
            <ul>
              <li dir="rtl">
                <p dir="rtl">עקב "כוח עליון" ומבלי לפגוע בכלליות האמור, מלחמה, פעולות איבה, מצבי חירום ונזקי טבע. שביתה ו/או השבתה אצל ספקי הסחורות הדרושים לייצור ו/או הובלת המוצרים.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">כל סיבה אחרת שאיננה בשליטת&nbsp;fbzipper.&nbsp;</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">fbzipper&nbsp;איננה מתחייבת לזמן אספקה כאשר הפריטים אינם נמצאים במלאי. אם פריטים מסוימים חסרים במלאי,&nbsp;fbzipper&nbsp;תמסור הודעה על כך למשתמש אשר יהא רשאי לבטל את ההזמנה.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">מועדי אספקת המוצרים ו/או השירותים כפי שאלה מצוינים בדף המכירה כוללים רק ימי עסקים קרי, ימים א-ה לא כולל שישי, שבת, ערבי חג וימי חג. מועד האספקה נמדד החל מקבלת אישור ההזמנה ע"י&nbsp;fbzipper.</p>
              </li>
            </ul>
          </li>
        </ul>
        <p dir="rtl">ביטול עסקה</p>
        <ol>
          <li dir="rtl">
            <p dir="rtl">המשתמש רשאי לבטל את העסקה שביצע באתר בהתאם להוראות חוק הגנת הצרכן, התשמ"א – 1981 והתקנות שהותקנו מכוחו (להלן: "חוק הגנת הצרכן").&nbsp;<br />על מנת לבטל את המנוי / העסקה יש לפתוח פנייה בטופס יצירת הקשר&nbsp;שבאתר, או לחלופין להיכנס לחלון של&nbsp;"חבילות שירות"&nbsp;ומיד לאחר מכן ללחוץ על הכפתור&nbsp;"ביטול והפסקת הפעילות", במידה והשתמשתם בתוכנה במשך 48 שעות או פחות תקבלו את כספכם בחזרה תוך 14 ימי עסקים כחוק ותופק חשבונית זיכוי,&nbsp;במידה ועברו יותר מ 48 שעות שימוש בתוכנה לא יהיה ניתן לקבל החזר כספי ותחוייבו באופן מלא בעבור השירות בהתאם לחבילה שבחרתם ובכפוף לתנאי השימוש ותופסק הפעילות באופן מיידי בתום ניצול החבילה.<br />הביטול יתאפשר בכפוף להסכמת יצרן התוכנה ובלבד שטרם בוצעה אקטיבציה לרישוי התוכנה. בכל שאלה הקשורה לבירורים, ביטולים, החזרות וכד' יש לפנות אל מחלקת שירות הלקוחות של&nbsp;fbzipper&nbsp;בדוא"ל:&nbsp;support@fbzipper.com&nbsp;או לפתוח פנייה&nbsp;דרך&nbsp;טופס יצירת הקשר&nbsp;שבאתר ונשמח לעזור.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">מוצרים שניתן לשכפל ו/או להעתיק ו/או להקליט ו/או מוצר תוכנה שהותקן ובוצעה לו אקטיבציה לא יהיו ניתנים להחזרה / ביטול / החלפה.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">החזר כספי במקרה של ביטול עסקה שאושר על ידי היצרן, יבוצע באמצעות זיכוי כרטיס האשראי שבו בוצעה העסקה בתוך 14 יום מקבלת הבקשה לביטול העסקה והמוצר המוחזר.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">משתמש חדש מקבל במתנה 14 ימי שימוש במערכת בחודש הראשון בלבד וזה כלול בחבילה שבחר (אלא אם צוין אחרת) על מנת שיוכל להתמצא בתוכנה / במערכת של&nbsp;fbzipper,&nbsp;ללמוד את התוכנה, להכין קמפיינים, ולהיות שלם עם החלטתו. המשתמש ישלם מראש על החבילה והימים שקיבל במתנה יתווספו באופן אוטומטי עם תחילת הפעילות. החיוב הבא יחל בסיום 6 שבועות מרגע התשלום הראשון ותחילת הפעילות וכך ימשך בהוראת קבע מידי חודש.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">במידה ומתעורר אצל המשתמש חשש שהמוצר פגום, עליו לפנות באופן מיידי לחברת&nbsp;fbzipper&nbsp;לקבלת שירות.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">fbzipper&nbsp;תפצה / תזכה על פי שיקול דעתה הבלעדי ובאופן יחסי משתמשים אשר חוו בעיות טכניות (באגים) במערכת שבעקבותם לא פורסמו הפוסטים שהיו צריכים להתפרסם.</p>
          </li>
        </ol>
        <p dir="rtl">ביטול עסקה על ידי&nbsp;fbzipper</p>
        <ul>
          <li dir="rtl">
            <p dir="rtl">fbzipper&nbsp;שומרת לעצמה את הזכות להפסיק בכל עת, על פי שיקול דעתה הבלעדי, את הפעילות באתר ו/או לבטל עסקת רכישה שביצע משתמש, לרבות, אך לא רק, בכל אחד מהמקרים המפורטים להלן:</p>
            <ul>
              <li dir="rtl">
                <p dir="rtl">אם נפלה טעות בהצגת המוצר בחנות ו/או באספקת המוצר אל המשתמש, בין אם במחיר המוצר ובין אם בתיאור ומפרט המוצר.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">אם יתגלה כי ארעה תקלה בתקשורת ו/או כל בעיה טכנית אחרת אשר שיבשה את מחיר המוצר ו/או תיאור המוצר.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">במקרה של מניעה ו/או עיכוב מחמת כוח עליון, כדוגמת, אך מבלי לגרוע מכלליות האמור: פעולת מלחמה, איבה ,טרור, חבלת סייבר, תקלה מכוונת או בלתי מכוונת באתר, במערכות תקשורת כלשהן ו/או תקלות מחשב, שביתות והשבתות, אירועי טבע חריגים, תקלות בסליקת כרטיסי אשראי וכל סיבה אחרת שאינה תוצאת מעשה או מחדל של&nbsp;fbzipper.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">במקרה בו החליטה&nbsp;fbzipper, על פי שיקול דעתה, כי קיים חשש שהרכישה מבוצעת במסגרת רכישה סיטונאית ו/או כי המוצרים נרכשים לצורך מכירה חוזרת על ידי הקונה או מי מטעמו. בהקשר זה המשתמש מאשר ומתחייב כי לא ימכור פריטים שרכש באתר לצד ג' כלשהו.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">אם המוצר אזל מהמלאי לפני או אחרי שהתבצעה העסקה.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">אם, לפי שיקול דעתה הבלעדי של&nbsp;fbzipper, קיים חשש שהתמורה בגין העסקה לא תשולם.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">אם לא נקלטו במערכת פרטי כרטיס האשראי ופרטיו המלאים של המשתמש.</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">בכל מקרה שבו נעשתה פעולה בניגוד לתקנון זה ו/או במקרה שהמשתמש ביצע מעשה בלתי חוקי ו/או עבר על הוראות הדין לרבות במקרה בו המשתמש מסר בעת ביצוע עסקת הרכישה ו/או לאחר מכן פרטים שגויים;</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">במקרה בו המשתמש ביצע מעשה או מחדל שיש בו כדי לפגוע בfbzipper&nbsp;ו/או במי מטעמה ו/או בפעילותו התקינה של האתר ו/או בצד ג' אחר כלשהו;</p>
              </li>
              <li dir="rtl">
                <p dir="rtl">בוטלה עסקה כאמור,&nbsp;fbzipper&nbsp;לא תהיה אחראית ולא תישא באחריות לנזק מסוג כלשהו לרבות לכל נזק ישיר, עקיף, תוצאתי או מיוחד שנגרם למשתמש או לצד שלישי לרבות אך לא רק נזק בגין רכישת המוצר ו/או השירות אצל צד שלישי במחיר גבוה יותר.</p>
              </li>
            </ul>
          </li>
        </ul>
        <p dir="rtl">&nbsp;אחריות כללית ופרסומית, אבטחה ופרטיות</p>
        <ul>
          <li dir="rtl">
            <p dir="rtl">חברת&nbsp;fbzipper&nbsp;אינה אחראית על הפרסומים שהמשתמשים יפרסמו דרך הפלטפורמה / המערכת / התוכנה בקבוצות הפייסבוק השונות או כל תוכן אחר שיפורסם דרך המערכת, והאחריות היא על המשתמשים בלבד! ולמשתמשים לא תהיה כל טענה נגד החברה בעקבות הפרות מכל סוג שיגרמו או עלולות להיגרם על ידי המשתמשים. הפרות לדוגמא - ספאם, זכויות יוצרים, לשון הרע, צד שלישי וכל הפרה אחרת.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">חברת&nbsp;fbzipper&nbsp;אינה אחראית במידה ונחסם / ננעל / נפגע אחד או יותר מהפרופילים (יוזרים בפייסבוק) של המשתמשים בתוכנה בעקבות שימוש כוזב / לא חוקי של המשתמשים שמפר את הכללים במערכת או את כללי הקהילה של פייסבוק.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">הנהלת האתר מתחייבת לשמור על סודיות מוחלטת בכל הקשור ללקוחות והנתונים הנמצאים אצלה, הן במשרדיה והן באתר האינטרנט.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">fbzipper&nbsp;ו/או מי מטעמה נוקטים באמצעי זהירות סבירים ומקובלים על מנת לשמור, ככל האפשר על סודיות המידע ולמנוע כניסה לא מורשית לאתר. פרטי ההתקשרות של המשתמש (שם ודואר אלקטרוני), יישמרו במערכות חברת&nbsp;fbzipper&nbsp;לצורך דיוור ישיר. להסרה, יש לפנות בכתב לשירות הלקוחות של&nbsp;fbzipper&nbsp;במייל:&nbsp;support@fbzipper.com. ביצוע ההסרה עשוי להימשך עד 14 ימי עבודה מיום קבלת הפנייה. ויודגש; פרטי כרטיסי האשראי של המשתמשים המבצעים פעולות באתר אינם נשמרים כלל במערכות&nbsp;fbzipper&nbsp;מאחר וfbzipper&nbsp;נעזרת בחברה חיצונית [פייפל - PayPal] לצורך סליקת כרטיסי האשראי.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">התקשורת בין מחשבי הלקוח לבין שרתי התוכנה מוגנת באמצעות פרוטוקול אבטחה SSL.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">מובהר כי מאחר ומדובר בביצוע פעולות בסביבה מקוונת, אין באפשרותה של&nbsp;fbzipper&nbsp;להבטיח חסינות מוחלטת מפני חדירות למחשביה או חשיפת המידע האגור בידי מבצעי פעולות בלתי חוקיות ועל כן, אם יעלה בידי צד שלישי לחדור למידע אשר שמור בידי&nbsp;fbzipper&nbsp;ו/או להשתמש בו לרעה, לא תהיה למשתמש כל טענה, תביעה או דרישה כלפי&nbsp;fbzipper. כמו כן, במקרים הנובעים מכוח עליון,&nbsp;fbzipper&nbsp;לא תהיה אחראית לכל נזק מכל סוג שהוא, עקיף או ישיר שייגרם למשתמש או למי מטעמו, אם מידע כלשהו שמסר יאבד או יגיע לגורם עוין ו/או יעשה בו שימוש שלא בהרשאה.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">fbzipper&nbsp;מתחייבת כי לא תעשה שימוש בפרטי המשתמשים הרשומים באתר אלא לצרכי תפעול האתר בלבד ועל מנת לאפשר את ביצוע הרכישה באתר, וכן, לצורך שמירת קשר עם המשתמש.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">למרות האמור לעיל,&nbsp;fbzipper&nbsp;תהא רשאית להעביר פרטיו האישיים של משתמש לצד שלישי במקרים בהם המשתמש ביצע מעשה או מחדל הפוגעים ו/או העלולים לפגוע בfbzipper&nbsp;ו/או בצדדים שלישיים כלשהם, המשתמש עשה שימוש בשירותי&nbsp;fbzipper&nbsp;לביצוע מעשה בלתי חוקי, אם התקבל בידי&nbsp;fbzipper&nbsp;צו שיפוטי המורה לה למסור את פרטי המשתמש לצד שלישי וכן בכל מחלוקת או הליך משפטי. כמו כן,&nbsp;fbzipper&nbsp;תוכל להשתמש בפרטיו האישיים של המשתמש, ללא זיהוי המשתמש הספציפי, לצורך ניתוח מידע סטטיסטי והצגתו ו/או מסירתו לגורמים אחרים.</p>
          </li>
        </ul>
        <p dir="rtl">גיבויים</p>
        <ul>
          <li dir="rtl">
            <p dir="rtl">כל הנתונים מגובים בגיבוי חם בזמן אמת. בנוסף, מתבצע גיבוי יומי של כל הנתונים אשר מועבר לשרת מרוחק הנמצא בחוות שרתים אחרת.</p>
          </li>
        </ul>
        <p dir="rtl">שירות לקוחות</p>
        <ul>
          <li dir="rtl">
            <p dir="rtl">לפרטים ובירורים באשר למוצרים ו/או לאספקתם ניתן לפנות אל מחלקת שירות הלקוחות של&nbsp;fbzipper&nbsp;בדוא"ל:&nbsp;<a href="mailto:support@fbzipper.com">support@fbzipper.com</a> או לפתוח פנייה&nbsp;דרך&nbsp;טופס יצירת הקשר&nbsp;שבאתר ונשמח לעזור.</p>
          </li>
        </ul>
        <p dir="rtl">קניין רוחני</p>
        <ul>
          <li dir="rtl">
            <p dir="rtl">כל זכויות הקניין הרוחני בכל התכנים באתר, לרבות סימני המסחר, הפטנטים, זכויות היוצרים, המדגמים, השיטות והסודות המסחריים, הינם רכושה של&nbsp;fbzipper&nbsp;ו/או של היצרן בלבד. זכויות אלה חלות, בין היתר, על עיצובו הגרפי של אתר&nbsp;<a href="http://fbzipper.com">fbzipper.com</a>, בסיסי הנתונים בו (לרבות רשימות המוצרים, תיאור המוצרים וכד'), קוד המחשב של האתר וכל פרט אחר הקשור בהפעלתו.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">אין לעשות כל שימוש מסחרי בנתונים המתפרסמים באתר&nbsp;fbzipper, בבסיס הנתונים באתר, ברשימות ובתמונות המוצרים המופיעים בו או בפרטים אחרים המתפרסמים על ידי ו/או מטעם&nbsp;fbzipper&nbsp;בלא קבלת הסכמת&nbsp;fbzipper&nbsp;מראש ובכתב. אין להשתמש בנתונים כלשהם המתפרסמים באתר&nbsp;fbzipper&nbsp;לצורך הצגתם באתר אינטרנט או בשירות אחר כלשהו בניגוד להוראות ההסכם ו/או בלא לקבל את הסכמת&nbsp;fbzipper&nbsp;מראש ובכתב ובכפוף לתנאי אותה הסכמה (אם וככל תינתן). בכלל זה נאסר לאסוף נתונים מן האתר באמצעות תוכנות ו/או להפיץ נתונים כאלה ברבים באופן מסחרי או במסגרת מסחרית.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">אין להעתיק, לשכפל, להפיץ, למכור, לשווק ולתרגם מידע כלשהו מן האתר (לרבות סימני מסחר, תמונות, טקסטים וקוד-מחשב בלא קבלת רשותה המפורשת של&nbsp;fbzipper&nbsp;מראש ובכתב. אין להציג את האתר בתוך מסגרת (Frame), גלויה או סמויה ואין לקשר לעמודים המצויים בתוכו ("קישור עומק"), אלא לעמוד הבית בלבד. אין להציג את האתר בעיצוב או ממשק גרפי שונים מאלה שעיצבה לו&nbsp;fbzipper, אלא בכפוף לקבלת הסכמתה לכך מראש ובכתב.</p>
          </li>
          <li dir="rtl">
            <p dir="rtl">השם&nbsp;fbzipper&nbsp;בע"מ, שם המותג (fbzipper), סימני המסחר של&nbsp;fbzipper&nbsp;(בין אם נרשמו ובין אם לאו), וכיו"ב - הם כולם רכושם של&nbsp;fbzipper&nbsp;ו/או היצרן בלבד. אין לעשות בהם שימוש בלא קבלת הסכמת&nbsp;fbzipper&nbsp;מראש ובכתב.</p>
          </li>
        </ul>
        <p dir="rtl">דין ושיפוט</p>
        <ul>
          <li dir="rtl">
            <p dir="rtl">הדין החל על תקנון זה, פירושו, תוקפו, תחולתו ואכיפתו ו/או על כל פעולה ו/או על סכסוך הנובע ממנו, הוא הדין של מדינת ישראל בלבד. כל מחלוקת בין הצדדים לתקנון זה לרבות בנוגע לביצועו, תחולתו, פירושו או תוקפו – תתברר בבית המשפט בעל הסמכות העניינית במחוז תל אביב-יפו.</p>
          </li>
        </ul>
      </div>


              </div>
            </div>
          </div>
        </div>
      </div>
      );
    }
}

Terms.propTypes = {};

Terms.defaultProps = {};

export default Terms;

